module.exports = __webpack_public_path__ + "img/61.2.TN.2428bbb6.png";